export enum CostBearerType {
  /** Privatzahler */
  PRIVATE_PAYER = 'PRIVATE_PAYER',
  /** Pflegekasse und/oder Krankenkasse */
  INSURANCE = 'INSURANCE',
  /** Sozialamt */
  WELFARE_OFFICE = 'WELFARE_OFFICE',
}

export const CostBearerTypeObject = {
  /** Privatzahler */
  PRIVATE_PAYER: 'PRIVATE_PAYER',
  /** Pflegekasse und/oder Krankenkasse */
  INSURANCE: 'INSURANCE',
  /** Sozialamt */
  WELFARE_OFFICE: 'WELFARE_OFFICE',
} as const;
